import { CancelReasonKey, CancelReasonKeyType } from "components/CancelRequest";

export const isReasonOther = (reason: CancelReasonKeyType | undefined) =>
  reason === CancelReasonKey.Other;

export const isReasonDissatisfied = (reason: CancelReasonKeyType | undefined) =>
  reason === CancelReasonKey.Dissatisfied;

export class CancelRequestModel {
  private _reason: CancelReasonKeyType;
  private _explanation: string;

  constructor(reason: CancelReasonKeyType, explanation?: string) {
    this._reason = reason;
    this._explanation = explanation || "";
  }

  get reason() {
    return this._reason;
  }

  get explanation() {
    return this._explanation;
  }

  isReasonOther() {
    return isReasonOther(this._reason);
  }

  isReasonDissatisfied() {
    return isReasonDissatisfied(this._reason);
  }
}
